/**
 * Eén allowlist voor alle rich-text HTML in de app.
 *
 * De HTML komt uit de editor (frontend/src/components/RichTextEditor.tsx) en
 * wordt op twee plekken gefilterd:
 *   - schrijfkant: backend/src/lib/sanitize.ts (sanitize-html, Node)
 *   - leeskant:    frontend/src/lib/sanitize.ts (DOMParser, browser)
 *
 * Twee filters omdat ze verschillende gaten dekken. De schrijfkant zorgt dat er
 * geen vijandige HTML in Firestore belandt — anders moet elke toekomstige
 * consument (export, mail, PDF) het opnieuw goed doen. De leeskant is nodig
 * omdat er al ongefilterde HTML in de database staat: e-learning-lessen zijn
 * vóór deze wijziging rechtstreeks opgeslagen zoals de beheerder ze typte.
 *
 * Deze lijst is de enige plek waar de regels staan, zodat de twee filters niet
 * uit elkaar kunnen lopen. Uitbreiden betekent: nadenken over wat een auteur
 * met die tag kan doen bij een lezer.
 */
/** Tags die de editor kan produceren, plus wat er historisch al opgeslagen is. */
export const RICH_TEXT_TAGS = [
    'p',
    'br',
    'hr',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'ul',
    'ol',
    'li',
    'blockquote',
    'strong',
    'b',
    'em',
    'i',
    'u',
    's',
    'code',
    'pre',
    'a',
    'img',
    'figure',
    'figcaption',
    'table',
    'thead',
    'tbody',
    'tfoot',
    'tr',
    'th',
    'td',
    'span',
    'div',
];
/** Attributen per tag. Alles wat hier niet staat wordt gestript — dus ook elke on*-handler en style. */
export const RICH_TEXT_ATTRS = {
    a: ['href', 'title', 'target', 'rel'],
    img: ['src', 'alt', 'title', 'width', 'height'],
};
/** Toegestane href-schema's. Blokkeert javascript:, data: en vbscript:. */
export const RICH_TEXT_HREF_SCHEMES = /^(https?:|mailto:)/i;
/** Toegestane src-schema's voor afbeeldingen. */
export const RICH_TEXT_SRC_SCHEMES = /^(https?:\/\/|data:image\/)/i;
/**
 * Ziet de opgeslagen tekst eruit als HTML uit de editor?
 *
 * Bestaande velden bevatten markdown (agenda, welkomstpaneel) of platte tekst
 * (nieuws). Die blijven leesbaar zolang niemand ze opnieuw opslaat, dus de
 * renderer moet beide aankunnen. Een tekst die met een tag begint komt uit de
 * editor; markdown en platte tekst beginnen met gewone tekens.
 *
 * Bewust conservatief: bij twijfel is het geen HTML en valt de renderer terug
 * op markdown. Een markdown-tekst per ongeluk als HTML renderen zou de opmaak
 * verliezen, andersom niet.
 */
export function looksLikeRichTextHtml(value) {
    return /^\s*<(p|h[1-6]|ul|ol|blockquote|pre|div|figure|table|hr|img)[\s/>]/i.test(value);
}
//# sourceMappingURL=rich-text.js.map